import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import { createCustNum } from '@/pages/settings/redux/slice';
//  createCategory
import { Col, Form, Input, Row, message, Select } from 'antd';
// import styles from './index.module.less';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CaretDownFilled
  // CaretDownOutlined,
  // DeleteOutlined,
  // HolderOutlined,
  // PlusCircleFilled,
  // RightOutlined
} from '@ant-design/icons';

const AddModal = ({
  onCancel,
  isModalVisible,
  setIsModalOpen,
  handlegetCostCenterNum
  // getCUSTNum_id
}) => {
  const dispatch = useDispatch();
  // const [isActive, setIsActive] = useState(getCUSTNum_id?.[0]?.is_active);
  const [form] = Form.useForm();
  const { Option } = Select;
  const {
    get_plants,
    get_functions
    // get_category,
    // get_subcategorylist,
    // get_activity
  } = useSelector((state) => state.dashboard);

  const onFinish = (values) => {
    dispatch(createCustNum(values)).then((response) => {
      if (response.payload.success) {
        message.success(response.payload.message);
        setIsModalOpen(false);
        handlegetCostCenterNum();
      } else {
        message.error(response.payload.message);
      }
    });
  };
  // const handleSwitchChange = (checked) => {
  //   setIsActive(checked);
  // };
  return (
    <CustomModal
      footer={
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row>
            <Col className="text-left" span={12}>
              <CustomButton onClick={onCancel}>Cancel</CustomButton>{' '}
            </Col>
            <Col className="text-right" span={12}>
              <CustomButton
                /* onClick={onOk} */ type="primary"
                htmlType="submit"
              >
                Add
              </CustomButton>
            </Col>
          </Row>
        </Form>
      }
      onCancel={onCancel}
      visible={isModalVisible}
      title="Add Cost Center"
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="ant-form ant-form-vertical"
      >
        <Row gutter={24}>
          {/* Plant */}
          <Col span={12}>
            <FormItem
              name="plant_id"
              label="Plant"
              rules={[
                {
                  required: true,
                  message: 'Please plant'
                }
              ]}
            >
              <Select
                filterOption={(inputValue, option) =>
                  option.props.children
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                // onSearch={handleSubCategorySearch}
                showSearch
                suffixIcon={<CaretDownFilled />}
                placeholder="Select Plant"
              >
                {get_plants
                  // ?.filter((item) => item.new_sub_cat_doa)
                  ?.map((item, index) => (
                    <Option key={index} value={item.id}>
                      {item.is_active === false
                        ? `${item.name} (Deactivated)`
                        : item.name}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          {/* Plant End  */}

          {/* Department */}
          <Col span={12}>
            <FormItem
              name="department_id"
              label="Department"
              rules={[
                {
                  required: true,
                  message: 'Please department'
                }
              ]}
            >
              <Select
                filterOption={(inputValue, option) =>
                  option.props.children
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                // onSearch={handleSubCategorySearch}
                showSearch
                suffixIcon={<CaretDownFilled />}
                placeholder="Select Department"
              >
                {get_functions
                  // ?.filter((item) => item.new_sub_cat_doa)
                  ?.map((item, index) => (
                    <Option key={index} value={item.id}>
                      {item.is_active === false
                        ? `${item.name} (Deactivated)`
                        : item.function_name}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          {/* Department End */}

          <Col span={24}>
            <FormItem
              label={'Cost Center'}
              name="name"
              // className={`${styles.astrick}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter cost center'
                }
              ]}
            >
              <Input placeholder="Enter cost center" />
            </FormItem>
          </Col>
          {/* <Col span={12}>
            <FormItem
              label={'cost center Amount'}
              name="amount"
              // className={`${styles.astrick}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter cost center amount'
                },
                {
                  pattern: /^\d*\.?\d*$/,
                  message: 'Please enter a valid numeric value'
                }
              ]}
            >
              <Input placeholder="Enter cost center amount" />
            </FormItem>
          </Col> */}
          {/* <Col span={24}>
            <FormItem
              label={'Status'}
              name="action"
              // className={`${styles.astrick}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter'
                }
              ]}
            >
              <div
                className={
                  isActive
                    ? `${styles.switcher_container}`
                    : `${styles.switcher_container1}`
                }
              >
                <Switch checked={isActive} onChange={handleSwitchChange} />
              </div>
            </FormItem> */}
          {/* </Col> */}
        </Row>
      </Form>
    </CustomModal>
  );
};

export default AddModal;
